<template>
  <div>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">Мои бронирования</div>
					<div class="card-body">
						<vuetable ref="vuetable"
							:fields="columns"
							:api-mode="false"
							:data="tableData"
							class="table-striped"
							noDataTemplate="Ничего не найдено"
						>
							<template slot="seats" slot-scope="props">
								{{ props.seats }}
									<ul class="seats-list">
										<li v-for="(seat, key2) in props.rowData.seats" v-bind:key="key2" @click="seatSetModalHandler(props.rowData, seat.id)"><b-badge :variant="getCategoryClass(seat.category)">{{ seat.seat }}</b-badge> {{ getUsername(seat.member) }}</li>
									</ul>
							</template>
							<template slot="actions" slot-scope="props">
								<b-dropdown variant="primary" size="sm" right split text="Действия">
									<b-dropdown-item @click="emailModalHandler(item.id)">Отправить билеты</b-dropdown-item>
									<b-dropdown-item @click="seatSetModalHandler(props.rowData)">Назначить места</b-dropdown-item>
									<b-dropdown-item divided @click="removeHandler(item.id, key)">Удалить</b-dropdown-item>
								</b-dropdown>
							</template>
						</vuetable>
					</div>
					<div class="card-footer">
						<b-button class="pull-right" variant="primary" @click="$router.push({ path: '/events/map/' + eventId })">Вернуться к схеме бронирования</b-button>
					</div>
				</div>
			</div>
		</div>
		<modal v-model="open" title="Данные о клиенте для билетов" @hide="modal" ref="modal" id="modalReservation">
			<div slot="footer">
        <btn @click="open=false">Отмена</btn>
        <btn v-if="!loading" type="info" @click="person">OK</btn>
      </div>
			<p style="color: #ff0000">Пожалуйста, отнесись к следующим поля максимально серьезно, без всяких смехуечков! Указаное ФИО будет отображаться на билетах!</p>
			<form v-if="!loading">
				<alert type="danger" v-if="alert" dismissible @dismissed="alert = false">{{ alertText }}</alert>
				<div class="form-group" :class="errors.firstName === true ? 'has-error' : ''">
					<label for="firstName">Имя</label>
					<input class="form-control" id="firstName" v-model="form.firstName" required />
				</div>
				<div class="form-group" :class="errors.lastName === true ? 'has-error' : ''">
					<label for="lastName">Фамилия</label>
					<input class="form-control" id="lastName" v-model="form.lastName" required />
				</div>
				<div class="form-group" :class="errors.middleName === true ? 'has-error' : ''">
					<label for="middleName">Отчество</label>
					<input class="form-control" id="middleName" v-model="form.middleName" required />
				</div>
			</form>
			<div v-if="loading" class="loading"></div>
    </modal>

		<modal v-model="emailModalShow" title="Отправка билетов" @hide="modal2" ref="modal">
			<div slot="footer">
        <btn @click="emailModalShow=false">Отмена</btn>
        <btn v-if="!loading" type="info" @click="sendEmail" :disabled="sendDisabled">OK</btn>
      </div>
			<alert type="danger" v-if="alert" dismissible @dismissed="alert = false">{{ alertText }}</alert>
			<form v-if="!loading">
				<div class="form-group">
					<label for="email">E-mail</label>
					<textarea class="form-control" id="email" v-model="email" required></textarea>
					<span class="help-block">Необходимо ввести хотя бы один адрес электронной почты. Если их несколько, укажите их через запятую.</span>
				</div>
			</form>
			<div v-if="loading" class="loading"></div>
    </modal>

		<b-modal id="modallg" v-model="seatManage.modal" cancel-title="Отмена" @ok="seatManageModalHandleOk" title="Назначение мест" class="modal-seat-manage">
			<div class="seat-manage-list row">
				<div class="col-sm-3 d-flex align-items-center"><b-badge :variant="getCategoryClass(seatManage.seat.category)">{{ seatManage.seat.seat }}</b-badge> {{ getCategoryText(seatManage.seat.category) }}</div>
				<div class="col-sm-9">
					<select v-model="seatManage.memberId"  class="form-control">
						<option v-for="(member, key) in seatManage.members" :key="key" :value="member.id">{{ member.last_name }} {{ member.first_name }} {{ member.middle_name }}</option>
						</select>
					</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import memberApi from '@/api/modules/event/member'
import seatApi from '@/api/modules/event/seat'
export default {
	data: function () {
		return {
			eventId: null,
			open: false,
			emailModalShow: false,
			modalSeatSelectShow: true,
			alert: false,
			alertText: '',
			seatManage: {
				modal: false,
				seat: {},
				memberId: 0,
				members: []
			},
			tableData: [],
			columns: [
				{
					name: 'id',
					title: 'ID'
				}, {
					name: 'b24_deal_id',
					title: 'ID сделки Б24'
				}, {
					name: '__slot:seats',
					title: 'Места'
				}, {
					name: 'status',
					title: 'Статус'
				}, {
					name: '__slot:actions',
					title: 'Действия'
				}
			],
			loading: true,
			sendDisabled: false,
			form: {
				firstName: '',
				lastName: '',
				middleName: '',
				seatId: null
			},
			email: '',
			reservationId: null,
			errors: []
		}
	},
	mounted: function () {
		this.eventId = this.$route.params.id
		this.myReservation()
	},
	methods: {
		myReservation () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/event/reservations', {
				params: {
					event_id: this.eventId
				}
			}, {
			}).then(function (response) {
				this.$store.commit('CALL_API_OFF')
				let data = response.data
				this.tableData = data
			}, function (response) {
			})
		},
		removeHandler: function (id, key) {
			console.log('delete')
			this.$alert({
				title: 'Подтвердите действие',
				content: 'Вы уверены что хотите отменить бронь? Это действие нельзя будет отменить!'
			}, (msg) => {
				if (msg === 'ok') {
					this.remove(id, key).then((result) => {
						if (result === true) {
							this.tableData.splice(key, 1)
							this.$notify({
								placement: 'bottom-right',
								content: 'Бронь успешно отменена!'
							})
						}
					})
				}
			})
		},
		person: function () {
			this.errors = []

			Object.keys(this.form).forEach((key) => {
				if (this.form[key] === '' || typeof this.form[key] === 'undefined') {
					this.errors.push(key)
				}
			})

			if (this.errors.length > 0) {
				return false
			}

			this.callPrsonApi().then((result) => {
				if (result === true) {
					this.resetModal()
					this.open = false
					this.$notify({
						placement: 'bottom-right',
						content: 'Данные сохранениы!'
					})
				} else {
					this.open = false
					this.$notify({
						placement: 'bottom-right',
						type: 'danger',
						content: 'Ошибка сервера!'
					})
				}
			})
		},
		remove: function (id) {
			return new Promise((resolve, reject) => {
				this.$http.post('https://tip24.ru/event/ajax/remove', {
					event_id: this.getQueryVariable('id'),
					revision_id: id
				}, {
				}).then(function (response) {
					// let data = response.data
					// this.items = data
					resolve(true)
				}, function (response) {
					reject(new Error('Request failed: ' + response.status))
				})
			})
		},
		callPrsonApi: function () {
			return new Promise((resolve, reject) => {
				this.$http.post('https://tip24.ru/event/ajax/person', {
					seat_id: this.form.seatId,
					first_name: this.form.firstName,
					last_name: this.form.lastName,
					middle_name: this.form.middleName
				}, {
				}).then(function (response) {
					resolve(true)
				}, function (response) {
					// reject(new Error('Request failed: ' + response.status))
					resolve(false)
					// reject(false)
				})
			})
		},
		modal: function (e) {
			if (e === 'cancel' || e === 'dismiss') {
				this.resetModal()
			}
			if (e === 'ok') {
				this.open = true
			}
		},
		modal2: function (e) {
			if (e === 'cancel' || e === 'dismiss') {
				// this.resetModal()
			}
			if (e === 'ok') {
				this.emailModalShow = true
			}
		},
		getStatusClass: function (val) {
			let categories = {
				0: 'info',
				1: 'success'
			}
			return categories[val]
		},
		getStatusText: function (val) {
			let categories = {
				0: 'Не оплачено',
				1: 'Оплачено'
			}
			return categories[val]
		},
		getCategoryClass: function (val) {
			let categories = {
				vip: 'danger',
				business: 'warning',
				standard: 'secondary'
			}
			return categories[val]
		},
		getCategoryText: function (val) {
			let categories = {
				vip: 'VIP',
				business: 'Бизнес',
				standard: 'Стандарт'
			}
			return categories[val]
		},
		getQueryVariable: function (name) {
			var query = window.location.search.substring(1)
			var vars = query.split('&')
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (decodeURIComponent(pair[0]) === name) {
					return decodeURIComponent(pair[1])
				}
			}
		},
		getUsername (member) {
			if (member === null) return ''
			return member.last_name + ' ' + member.first_name + ' ' + member.middle_name
		},
		seatPerson: function (id) {
			this.resetModal()
			this.$http.get('https://tip24.ru/event/ajax/get-persone?seat_id=' + id, {}, {
			}).then(function (response) {
				let data = response.data
				this.form.firstName = data.first_name
				this.form.lastName = data.last_name
				this.form.middleName = data.middle_name
			}, function (response) {
			})
			this.form.seatId = id
			this.open = true
			this.loading = false
		},
		emailModalHandler: function (id) {
			this.$http.get('https://tip24.ru/event/ajax/reservation?id=' + id, {}, {
			}).then(function (response) {
				this.loading = false
				this.emailModalShow = true
				this.reservationId = id
				let data = response.data
				this.email = data.data.email
			}, function (response) {
			})
		},
		seatSetModalHandler (data, seatId) {
			const seats = data.seats
			if (seats.length === 0) return false
			seats.forEach((value, key) => {
				if (value.id === seatId) {
					this.seatManage.seat = seats[key]
					if (seats[key].member === null) return false
					this.seatManage.memberId = seats[key].member.id
				}
			})
			this.$store.commit('CALL_API_ON')
			memberApi.findAll({b24_id: data.b24_deal_id}).then((response) => {
				this.seatManage.members = response
				this.seatManage.modal = true
				this.$store.commit('CALL_API_OFF')
			}, (response) => {
				this.$store.commit('CALL_API_OFF')
			})
			// this.seatManage.modal = true
		},
		seatManageModalHandleOk (e) {
			const seatId = this.seatManage.seat.id
			const memberId = this.seatManage.memberId
			const members = this.seatManage.members
			if (seatId < 1 && memberId < 1) return false
			const data = {
				member_id: memberId
			}
			seatApi.update(seatId, data).then((response) => {
				members.forEach((member) => {
					if (member.id === memberId) {
						this.tableData.forEach((item, key) => {
							item.seats.forEach((seat, key2) => {
								if (seat.id === seatId) {
									this.tableData[key].seats[key2].member = member
								}
							})
						})
					}
				})
			})
		},
		sendEmail: function () {
			if (this.email === '') {
				return false
			}

			this.toggleSendDisabled()

			this.$http.post('https://tip24.ru/event/ajax/send-email', {
				id: this.reservationId,
				email: this.email
			}, {
			}).then(function (response) {
				this.toggleSendDisabled()
				this.alertText = ''
				this.alert = false
				this.email = ''
				this.emailModalShow = false
				this.loading = true
			}, function (response) {
				this.toggleSendDisabled()
				this.alert = true
				this.alertText = 'Вы указали ФИО не всех участников!'
			})
		},
		resetModal: function () {
			this.form.firstName = ''
			this.form.lastName = ''
			this.form.middleName = ''
			this.errors = {}
			this.loading = true
			this.alert = false
			this.alertText = ''
		},
		toggleSeatInfo: function (val) {
			if (this.popover === val) {
				this.popover = ''
			} else {
				this.popover = val
			}
		},
		toggleSendDisabled: function () {
			this.sendDisabled = !this.sendDisabled
		}
	}
}
</script>
<style>
.remove {
	color: #ff0000;
}
ul.seats-list, .seat-manage-list {
	padding: 0;
	margin: 0;
	list-style: none;
}
ul.seats-list li {
	position: relative;
	display: block;
	margin-bottom: 5px;
	cursor: pointer;
}
ul.seats-list li:last-child {
	margin-bottom: 0;
}

.label {
	text-transform: lowercase;
	font-size: 12px;
	font-weight: bold;
}

.seats-list .label {
	text-transform: uppercase;
}

.loading::after {
	position: absolute;
	left: calc(50% - (1.5em / 2));
	top: calc(50% - (1.5em / 2));
	position: absolute!important;
}

.loading {
	position: relative;
	width: 32px;
	height: 32px;
	margin: 20px auto;
}

.loading::after {
	-webkit-animation: spinAround .5s infinite linear;
	animation: spinAround .5s infinite linear;
	border: 2px solid #dbdbdb;
	border-radius: 290486px;
	border-right-color: transparent;
	border-top-color: transparent;
	content: "";
	display: block;
	height: 1.5em;
	position: relative;
	width: 1.5em;
}

.modal-seat-manage .badge {
	margin-right: 5px;
}

@-webkit-keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}
@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/reservation.vue